import React from 'react'
import { motion } from 'framer-motion'
import { useInView } from 'react-intersection-observer'
import { Users, Award, Clock, Shield } from 'lucide-react'
import WaterfallFadeIn from './WaterfallFadeIn'

const StatsSection = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  })

  const stats = [
    {
      icon: Users,
      value: '1,000+',
      label: 'Trusted Patients',
      description: 'Trusted by leading hospitals and clinics'
    },
    {
      icon: Award,
      value: '13+',
      label: 'Years Experience',
      description: 'Industry expertise and innovation'
    },
    {
      icon: Clock,
      value: '24/7',
      label: 'Support Available',
      description: 'Round-the-clock technical assistance'
    },
    {
      icon: Shield,
      value: '99.9%',
      label: 'Uptime Guarantee',
      description: 'Reliable and consistent performance'
    },
  ]

  return (
    <section className="section-padding bg-gradient-to-r from-gray-100 to-gray-200">
      <div className="container-custom">
        <motion.div
          ref={ref}
          initial={{ opacity: 0, y: 50 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Trusted by Healthcare Professionals Worldwide
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Our commitment to excellence has made us the preferred choice for medical imaging solutions
          </p>
        </motion.div>

        <WaterfallFadeIn
          baseDelay={0.1}
          duration={0.8}
          direction="up"
          distance={50}
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8"
        >
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300">
                <div className="w-16 h-16 bg-gradient-to-br from-primary-500 to-accent-400 rounded-full flex items-center justify-center mx-auto mb-6">
                  <stat.icon className="w-8 h-8 text-white" />
                </div>
                <div className="text-4xl font-bold text-gray-900 mb-2">
                  {stat.value}
                </div>
                <div className="text-lg font-semibold text-primary-500 mb-2">
                  {stat.label}
                </div>
                <div className="text-gray-600 text-sm">
                  {stat.description}
                </div>
              </div>
            </div>
          ))}
        </WaterfallFadeIn>
      </div>
    </section>
  )
}

export default StatsSection 